"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bundle_1 = require("swiper/element/bundle");
var modules_1 = require("swiper/modules");
(0, bundle_1.register)();
var topSwiperEl = document.querySelector("swiper-container.top-swiper");
if (topSwiperEl) {
    var swiperOptions = {
        modules: [modules_1.Pagination, modules_1.Navigation, modules_1.Autoplay],
        slidesPerView: 1.25,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        pagination: {
            enabled: true,
            el: "swiper-pagination",
            type: "bullets",
        },
        navigation: {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 3,
                spaceBetween: 28,
                slidesOffsetBefore: 28,
                slidesOffsetAfter: 28,
            },
        },
    };
    Object.assign(topSwiperEl, swiperOptions);
    topSwiperEl.initialize();
}
function initTopNewsSwiper(container) {
    var _a;
    var swiperOptions = {
        modules: [modules_1.Scrollbar, modules_1.Autoplay],
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 24,
        loop: true,
        scrollbar: {
            hide: false,
            el: (_a = container.querySelector(".swiper-scrollbar")) !== null && _a !== void 0 ? _a : "swiper-scrollbar",
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1024: {
                spaceBetween: 48,
            },
        },
    };
    Object.assign(container, swiperOptions);
    container.initialize();
}
document.querySelectorAll("swiper-container.top-news-swiper").forEach(function (el) { return initTopNewsSwiper(el); });
function initLineupSwiper(container) {
    var _a;
    var swiperOptions = {
        modules: [modules_1.Scrollbar, modules_1.Autoplay],
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 24,
        loop: true,
        scrollbar: {
            hide: false,
            el: (_a = container.querySelector(".swiper-scrollbar")) !== null && _a !== void 0 ? _a : "swiper-scrollbar",
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1024: {
                spaceBetween: 48,
            },
        },
    };
    Object.assign(container, swiperOptions);
    container.initialize();
}
document.querySelectorAll("swiper-container.top-lineup-swiper").forEach(function (el) { return initLineupSwiper(el); });
function initShopCouponProductSwiper(container) {
    var _a;
    var swiperOptions = {
        modules: [modules_1.Scrollbar],
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 24,
        loop: true,
        scrollbar: {
            hide: false,
            el: (_a = container.querySelector(".swiper-scrollbar")) !== null && _a !== void 0 ? _a : "swiper-scrollbar",
        },
        breakpoints: {
            1024: {
                spaceBetween: 48,
            },
        },
    };
    Object.assign(container, swiperOptions);
    container.initialize();
}
document
    .querySelectorAll("swiper-container.shop-coupon-product-swiper")
    .forEach(function (el) { return initShopCouponProductSwiper(el); });
var topNewOpenSwiperEl = document.querySelector("swiper-container.top-new-open-swiper");
if (topNewOpenSwiperEl) {
    var swiperOptions = {
        modules: [modules_1.Scrollbar, modules_1.Autoplay],
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 24,
        loop: false,
        scrollbar: {
            hide: false,
            el: ".top-new-open-swiper .swiper-scrollbar",
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1024: {
                spaceBetween: 48,
            },
        },
    };
    Object.assign(topNewOpenSwiperEl, swiperOptions);
    topNewOpenSwiperEl.initialize();
}
var commonSwiperEl = document.querySelectorAll("swiper-container.swiper-type-1");
commonSwiperEl.forEach(function (container) {
    var _a;
    var swiperOptions = {
        modules: [modules_1.Scrollbar, modules_1.Autoplay],
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 24,
        loop: true,
        scrollbar: {
            hide: false,
            el: (_a = container.querySelector(".swiper-scrollbar")) !== null && _a !== void 0 ? _a : "swiper-scrollbar",
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1024: {
                spaceBetween: 48,
            },
        },
    };
    Object.assign(container, swiperOptions);
    container.initialize();
});
var itemMainEl = document.querySelector("swiper-container.item-image-swiper");
var itemThumbEls = document.querySelectorAll(".item-image-thumbs__item");
if (itemMainEl) {
    Object.assign(itemMainEl, {
        modules: [modules_1.EffectFade],
        effect: "fade",
        slidesPerView: "auto",
        fadeEffect: { crossFade: true },
        loop: true,
    });
    itemMainEl.initialize();
    var setActiveThumb_1 = function (index) {
        itemThumbEls.forEach(function (thumb, i) { return thumb.classList.toggle("is-active", i === index); });
    };
    itemThumbEls.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
            var _a;
            var index = Number((_a = thumb.dataset.thumbIndex) !== null && _a !== void 0 ? _a : 0);
            itemMainEl.swiper.slideToLoop(index);
        });
    });
    itemMainEl.swiper.on("realIndexChange", function () { return setActiveThumb_1(itemMainEl.swiper.realIndex); });
    setActiveThumb_1(itemMainEl.swiper.realIndex);
}
